<script>
	import { onMount } from "svelte";
	import mapboxgl from "mapbox-gl";
	import Select from "svelte-select";

	let apiError = false;
	mapboxgl.accessToken = cap_vars.click_amap_mapboxapi;
	if (!mapboxgl.accessToken) apiError = true;

	const apiURL = cap_vars.amap_api_url;
	const apiDropdownURL = cap_vars.amap_dropdown_url;

	let loading = true,
		post_codes = $$props.cp,
		etat = $$props.etat,
		type = $$props.type ? $$props.type : null,
		autoselectCP = [],
		map_filters = {
			amap: true,
			ferme: true,
			cp: ""
		},
		map_data = {
			ferme: null,
			amap: null
		},
		map_data_filtered = {
			ferme: null,
			amap: null
		},
		popup = false,
		map,
		amaps = [],
		fermes = [],
		amapsURL = apiURL + "&filter=amap&cp=" + post_codes,
		fermesURL = apiURL + "&filter=ferme&cp=" + post_codes,
		dropdownListURL = apiDropdownURL,
		amaps_count = "",
		fermes_count = "";

	amapsURL = etat ? `${amapsURL}&etat=${etat}` : amapsURL;

	console.log($$props);

	async function getAmaps() {
		if (!type || type === "amap") {
			let amapsJSON = await fetch(amapsURL);
			amaps = await amapsJSON.json();
			// console.log(amaps);
			map_data.amap = amaps;
			map_data_filtered.amap = amaps;
			amaps_count = await amaps.features.length;
			drawLayer(amaps, "amap");
			return amaps;
		}
	}

	async function getFermes() {
		if (!type || type === "paysan") {
			let fermesJSON = await fetch(fermesURL);
			fermes = await fermesJSON.json();
			fermes_count = await fermes.features.length;
			map_data.ferme = fermes;
			map_data_filtered.ferme = fermes;
			drawLayer(fermes, "ferme");
			return fermes;
		}
	}

	async function amapsFermesDropdown(filterText) {
		let call = await fetch(
			dropdownListURL + "&filtername=" + encodeURI(filterText)
		);
		let json = await call.json();
		return json;
	}

	async function communesDropdown(filterText) {
		let call = await fetch(
			"https://geo.api.gouv.fr/communes?codeRegion=84&fields=nom,centre&nom=" +
				encodeURI(filterText)
		);
		let json = await call.json();

		let formattedCommunes = json.map(commune => {
			return {
				value: commune.nom,
				label: commune.nom,
				coordinates: commune.centre.coordinates
			};
		});

		return formattedCommunes;
	}

	function communeGoto(event) {
		clearPopups();

		map.easeTo({
			center: event.detail.coordinates,
			zoom: 11,
			essential: true // this animation is considered essential with respect to prefers-reduced-motion
		});
	}

	function amapsFermesGoto(event) {
		if (popup) {
			//clearPopups();
		}
		let props = event.detail.properties ? event.detail.properties : null;

		popup = new mapboxgl.Popup()
			.setLngLat(event.detail.coordinates)
			.setHTML(setPopupHtml(event.detail.properties))
			.addTo(map);

		map.easeTo({
			center: event.detail.coordinates,
			zoom: 11,
			essential: true // this animation is considered essential with respect to prefers-reduced-motion
		});
	}

	function clearPopups() {
		if (popup === false) return;
		popup.remove();
	}

	onMount(async () => {
		console.log($$props);
		map = new mapboxgl.Map({
			container: "map",
			maxZoom: $$props.zoommax ? parseInt($$props.zoommax) : 20,
			minZoom: $$props.zoommin ? parseInt($$props.zoommin) : 5,
			style: "mapbox://styles/labubulle/ckv0jeyg30qj414vot4szbxyg"
			//style: "mapbox://styles/mapbox/light-v11",
		});

		map.on("load", data => {
			getAmaps();
			getFermes();
			map.resize();
			map.easeTo({
				center: $$props.position.split(","),
				zoom: parseFloat($$props.zoom) + 1
			});
		});
	});

	function drawLayer(data, label) {
		let color = label == "amap" ? "#DF542F" : "#3A7C3C";

		map.addSource(label, {
			type: "geojson",
			data: {
				type: "FeatureCollection",
				features: map_data[label].features
			},
			cluster: true,
			clusterMaxZoom: 9, // Max zoom to cluster points on
			clusterRadius: 80 // Radius of each cluster when clustering points (defaults to 50)
		});

		map.addLayer({
			id: label + "_clusters",
			type: "circle",
			source: label,
			filter: ["has", "point_count"],
			paint: {
				"circle-color": "#ffffff",
				"circle-stroke-width": 2,
				"circle-stroke-color": color,
				"circle-radius": [
					"step",
					["get", "point_count"],
					10,
					10,
					20,
					30,
					20,
					100,
					30
				]
			}
		});

		// inspect a cluster on click

		map.on("click", label + "_clusters", e => {
			const features = map.queryRenderedFeatures(e.point, {
				layers: [label + "_clusters"]
			});
			const clusterId = features[0].properties.cluster_id;
			map.getSource(label).getClusterExpansionZoom(clusterId, (err, zoom) => {
				if (err) return;
				map.easeTo({
					center: features[0].geometry.coordinates,
					zoom: zoom + 1
				});
			});
		});

		map.addLayer({
			id: label + "_cluster_count",
			type: "symbol",
			source: label,
			filter: ["has", "point_count"],
			layout: {
				"text-field": "{point_count_abbreviated}",
				"text-font": ["DIN Offc Pro Bold", "Arial Unicode MS Bold"],
				"text-size": 14
			},
			paint: {
				"text-color": color
			}
		});

		map.addLayer({
			id: label + "_unclustered_point",
			type: "circle",
			source: label,
			filter: ["!", ["has", "point_count"]],
			paint: {
				"circle-color": color,
				"circle-radius": 7,
				"circle-stroke-width": 2,
				"circle-stroke-color": "#fff"
			}
		});

		map.on("click", label + "_unclustered_point", e => {
			console.log(e.features[0].properties);
			const coordinates = e.features[0].geometry.coordinates.slice();
			const props = e.features[0].properties;

			while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
				coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
			}

			map.on("mouseenter", label + "_unclustered_point", () => {
				map.getCanvas().style.cursor = "pointer";
			});
			map.on("mouseleave", label + "_unclustered_point", () => {
				map.getCanvas().style.cursor = "";
			});

			map.easeTo({
				center: [coordinates[0], coordinates[1] - 0.02],
				zoom: 12
			});
			setTimeout(() => {
				popup = new mapboxgl.Popup()
					.setLngLat(coordinates)
					.setHTML(setPopupHtml(props))
					.addTo(map);
			}, 500);
		});

		loading = false;
	}

	function setPopupHtml(props) {
		console.log(props);

		let adresse =
				typeof props.adresse === "object"
					? props.adresse
					: JSON.parse(props.adresse),
			livraisonHoraires =
				typeof props.livraisonHoraires === "object"
					? props.livraisonHoraires
					: JSON.parse(props.livraisonHoraires),
			typeProduction =
				typeof props.typeProduction === "object"
					? props.typeProduction
					: JSON.parse(props.typeProduction),
			email = props.email,
			url = props.url,
			etat =
				props.amapEtat && props.amapEtat === "creation"
					? "En cours de création"
					: null;

		let html = `<div class="cap_map_popup cap_map_popup_type_${props.type}">`;
		html += etat ? `<span class='cap_map_popup_etat'>${etat}</span>` : "";
		html += `<h4>${props.nom}</h4>`;

		if (typeProduction[0] !== null) {
			html += `<div class='cap_map_popup_data_container'><b>Produits :</b>`;
			html += `<div><p>`;
			typeProduction.forEach((type, key) => {
				html += key != 0 ? ", " : "";
				html += `${type}`;
			});
			html += `</p></div></div>`;
		}

		if (adresse[0] !== null) {
			html += `<div class='cap_map_popup_data_container'><b>Livraisons :</b>`;
			html += `<div>`;
			html += `<p>${adresse.rue ? adresse.rue : ""}</p>`;
			html += `<p>${adresse.cp ? adresse.cp : ""} &nbsp; ${
				adresse.ville ? adresse.ville : ""
			}</p>`;
			html += `</div></div>`;
		}

		if (typeof livraisonHoraires[0] == "object") {
			livraisonHoraires.forEach(saison => {
				html += `<div class='cap_map_popup_data_container'>`;
				html += `<b>${saison.saison ? saison.saison + " :" : ""}</b><p>`;
				html += `${saison.jour ? saison.jour : ""} ${
					saison.debut ? saison.debut : ""
				} / ${saison.fin ? saison.fin : ""}</p>`;
				html += `</p></div>`;
			});
		}
		if (props.amapEtat && props.amapEtat === "creation") {
			html += `<div class='cap_map_popup_message_container'>`;
			html += `<p>Pour rejoindre l'AMAP ou aider ce projet, contactez directement le collectif et/ou contactez-nous à <a href="mailto:contact@amap-aura.org">contact@amap-aura.org</a>.</p>`;
			html += `</div>`;
		}

		if (email) {
			html += `<div class='cap_map_popup_data_container'><b>Email :</b>`;
			html += `<a href="mailto:${email}" target="_blank">${email}</a></p>`;
			html += `</div>`;
		}

		if (url) {
			html += `<div class='cap_map_popup_data_container'><b>Site internet :</b>`;
			html += `<a href="${url}" target="_blank">${url}</a></p>`;
			html += `</div>`;
		}

		html += `</div>`;

		return html;
	}

	function filterMap(code) {
		let allAmaps = map_data.amap.features,
			allFermes = map_data.ferme.features;

		// Filtrage des amaps
		let filtered_amaps = allAmaps.filter(feature => {
			return feature.properties.adresse.cp.startsWith(code);
		});

		map.getSource("amap").setData({
			type: "FeatureCollection",
			features: filtered_amaps
		});
		amaps_count = filtered_amaps.length;

		// Filtrage des fermes
		let filtered_fermes = allFermes.filter(feature => {
			return feature.properties.adresse.cp.startsWith(code);
		});

		map.getSource("ferme").setData({
			type: "FeatureCollection",
			features: filtered_fermes
		});
		fermes_count = filtered_fermes.length;
	}

	function toggleFilter(filter) {
		map_filters[filter] = !map_filters[filter];
		if (!map_filters[filter]) {
			map.setLayoutProperty(filter + "_clusters", "visibility", "none");
			map.setLayoutProperty(filter + "_cluster_count", "visibility", "none");
			map.setLayoutProperty(filter + "_unclustered_point", "visibility", "none");
		} else {
			map.setLayoutProperty(filter + "_clusters", "visibility", "visible");
			map.setLayoutProperty(filter + "_cluster_count", "visibility", "visible");
			map.setLayoutProperty(
				filter + "_unclustered_point",
				"visibility",
				"visible"
			);
		}
	}

	const toggleFullScreen = () => {
		document.getElementById("cap_map_wrapper").classList.toggle("fullscreen");
		map.resize();
	};
</script>

{#if apiError}
	<p class="cap_error cap_message" style="padding: 1em;">
		Clef d'API Mapbox non renseignée. Veuillez contacter l'administrateur du site.
	</p>
{:else}
	<div class="cap_map_mapbox {loading === true ? 'loading' : ''}">
		<span
			class="cap_map_white_box cap_map_toggle_fullscreen"
			on:click={() => toggleFullScreen()}
		>
			<svg
				id="expand_button"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 540 540"
				width="30px"
			>
				<g id="expand">
					<path
						d="m219.26,84.76h-115.41c-10.27,0-19.09,8.44-19.09,18.82,0,38.46.01,76.94.01,115.4,0,24.47,37.91,24.68,37.91.27,0-23.27,0-46.53,0-69.8,27.25,27.25,54.52,54.51,81.77,81.76,17.27,17.27,43.97-9.63,26.66-26.94-27.21-27.21-54.41-54.41-81.62-81.61h69.51c24.46.01,24.68-37.9.27-37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m417.32,320.73c0,23.27,0,46.52,0,69.79l-81.77-81.77c-17.27-17.27-43.97,9.63-26.66,26.94,27.21,27.21,54.41,54.41,81.62,81.62-23.17,0-46.34,0-69.51,0-24.47,0-24.68,37.91-.27,37.91,38.47,0,76.95-.01,115.41-.01,10.27,0,19.09-8.44,19.09-18.82,0-38.46-.01-76.93-.01-115.4,0-24.48-37.9-24.69-37.9-.28Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m320.74,122.69c23.27,0,46.52,0,69.79,0-27.25,27.25-54.51,54.51-81.77,81.76-17.27,17.27,9.63,43.97,26.94,26.66,27.21-27.2,54.41-54.4,81.62-81.6,0,23.16,0,46.33,0,69.5,0,24.47,37.91,24.68,37.91.27,0-38.46-.01-76.94-.01-115.4,0-10.27-8.44-19.09-18.82-19.09-38.46,0-76.93.01-115.4.01-24.48,0-24.69,37.9-.28,37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m219.26,417.31c-23.27,0-46.53,0-69.79,0,27.25-27.25,54.51-54.51,81.76-81.76,17.27-17.27-9.63-43.97-26.94-26.66-27.21,27.2-54.41,54.41-81.61,81.61v-69.5c0-24.47-37.91-24.68-37.91-.27v115.4c0,10.27,8.44,19.09,18.82,19.09,38.47,0,76.94-.01,115.4-.01,24.48,0,24.7-37.9.29-37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
				</g>
				<g id="reduce" style="opacity: 0;">
					<path
						d="m102.96,237.45h115.41c10.27,0,19.09-8.44,19.09-18.82,0-38.46-.01-76.94-.01-115.4,0-24.47-37.91-24.68-37.91-.27,0,23.27,0,46.53,0,69.8-27.25-27.25-54.52-54.51-81.77-81.76-17.27-17.27-43.97,9.63-26.66,26.94,27.21,27.21,54.41,54.41,81.62,81.61h-69.51c-24.46-.01-24.68,37.9-.27,37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m340.45,437.04c0-23.27,0-46.52,0-69.79,27.25,27.25,54.51,54.51,81.77,81.77,17.27,17.27,43.97-9.63,26.66-26.94-27.21-27.21-54.41-54.41-81.62-81.62,23.17,0,46.34,0,69.51,0,24.47,0,24.68-37.91.27-37.91-38.47,0-76.95.01-115.41.01-10.27,0-19.09,8.44-19.09,18.82,0,38.46.01,76.93.01,115.4,0,24.48,37.9,24.69,37.9.28Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m437.05,199.54c-23.27,0-46.52,0-69.79,0,27.25-27.25,54.51-54.51,81.77-81.76,17.27-17.27-9.63-43.97-26.94-26.66-27.21,27.2-54.41,54.4-81.62,81.6,0-23.16,0-46.33,0-69.5,0-24.47-37.91-24.68-37.91-.27,0,38.46.01,76.94.01,115.4,0,10.27,8.44,19.09,18.82,19.09,38.46,0,76.93-.01,115.4-.01,24.48,0,24.69-37.9.28-37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
					<path
						d="m102.95,340.45c23.27,0,46.53,0,69.79,0-27.25,27.25-54.51,54.51-81.76,81.76-17.27,17.27,9.63,43.97,26.94,26.66,27.21-27.2,54.41-54.41,81.61-81.61,0,23.17,0,46.34,0,69.5,0,24.47,37.91,24.68,37.91.27,0-38.46,0-76.94,0-115.4,0-10.27-8.44-19.09-18.82-19.09-38.47,0-76.94.01-115.4.01-24.48,0-24.7,37.9-.29,37.9Z"
						style="fill:#363636; stroke-width:0px;"
					/>
				</g>
				<path
					d="m459.18,540H80.82c-44.56,0-80.82-36.25-80.82-80.82V80.82C0,36.25,36.25,0,80.82,0h378.37c44.56,0,80.82,36.25,80.82,80.82v378.37c0,44.56-36.25,80.82-80.82,80.82ZM80.82,30c-28.02,0-50.82,22.8-50.82,50.82v378.37c0,28.02,22.8,50.82,50.82,50.82h378.37c28.02,0,50.82-22.8,50.82-50.82V80.82c0-28.02-22.8-50.82-50.82-50.82H80.82Z"
					style="fill:#363636; stroke-width:0px;"
				/>
			</svg>
		</span>
		<div class="cap_map_white_box cap_map_info">
			{#if !type || type === "amap"}
				<span class="cap_map_info_group cap_map_info_group_amap"
					><span class="cap_map_pill cap_map_count">{amaps_count}</span> AMAP</span
				>
			{/if}
			{#if !type || type === "paysan"}
				<span class="cap_map_info_group cap_map_info_group_paysan"
					><span class="cap_map_pill cap_map_count">{fermes_count}</span> Paysan·ne</span
				>
			{/if}
		</div>
		<div class="cap_map_white_box cap_map_filters">
			{#if !type}
				<h3>Filtrer par :</h3>
				<span
					class="cap_map_info_group cap_map_info_group_amap"
					on:click={() => toggleFilter("amap")}
				>
					<span
						class="cap_map_pill cap_map_radio {map_filters.amap === true
							? 'active'
							: ''}"
					/> AMAP
				</span>
				<span
					class="cap_map_info_group cap_map_info_group_paysan"
					on:click={() => toggleFilter("ferme")}
				>
					<span
						class="cap_map_pill cap_map_radio {map_filters.ferme === true
							? 'active'
							: ''}"
					/> Paysan·ne</span
				>
			{/if}
			<!--

      <input
        class="cap_codepostal"
        type="text"
        placeholder="Code postal"
        autocomplete="false"
        bind:value={map_filters.cp}
        on:input={() => filterMap(map_filters.cp)}
      />
    -->

			<h3>Rechercher :</h3>

			<div class="dropdown">
				<Select
					containerStyles="width:100%"
					loadOptions={communesDropdown}
					showChevron={false}
					placeholder={"Une commune"}
					placeholderAlwaysShow={false}
					noOptionsMessage="Saisissez un nom"
					on:select={communeGoto}
					on:clear={clearPopups}
				/>
			</div>

			<div class="dropdown">
				<Select
					containerStyles="width:100%"
					loadOptions={amapsFermesDropdown}
					showChevron={false}
					placeholder={!type
						? "PAYSAN·NE ou AMAP"
						: type === "amap"
							? "AMAP"
							: "PAYSAN·NE"}
					placeholderAlwaysShow={false}
					noOptionsMessage="Saisissez un nom"
					on:select={amapsFermesGoto}
					on:clear={clearPopups}
				/>
			</div>
		</div>
		<div id="map" />
	</div>
{/if}

<!-- .cap_map_mapbox -->
<style scss>
	.dropdown {
		width: 100%;
		margin-bottom: 0.5em;
		--height: 30px;
		--placeholderOpacity: 1;
		--listEmptyPadding: 5px;
		--listEmptyTextAlign: left;
		--selectedItemPadding: 0;
		--internalPadding: 0;
		--padding: 5px;
		--clearSelectTop: 0;
		--clearSelectBottom: 0;
	}
	.dropdown input {
		text-transform: uppercase;
	}
	.dropdown ::placeholder {
		text-transform: uppercase;
		opacity: 1 !important;
	}
	.dropdown .empty {
		font-weight: normal !important;
		font-size: 0.8em;
	}
</style>
